import React from "react";
import { useNavigate } from "react-router-dom";
import { useStateContext } from "../contexts/ContextProvider";

const Button = ({
  icon,
  bgColor,
  color,
  bgHoverColor,
  size = "base", // 기본 값 설정
  text,
  borderRadius = "5px", // 기본 값 설정
  width = "auto", // 기본 값 설정
  marginRight,
  navigateTo, // 추가: 이동할 경로
  onClick, // 추가: 사용자 정의 클릭 이벤트 핸들러
  disabled
}) => {
  const { setIsClicked, initialState } = useStateContext();
  const navigate = useNavigate();

  const handleClick = () => {
    setIsClicked(initialState);
    if (onClick) {
      onClick(); // 사용자 정의 이벤트 호출
    }
    if (navigateTo) {
      navigate(navigateTo); // 페이지 이동
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick} // 클릭 핸들러
      style={{
        backgroundColor: bgColor,
        color,
        borderRadius,
        marginRight: marginRight,
      }}
      className={`text-${size} p-3 w-${width} hover:drop-shadow-xl hover:bg-${bgHoverColor}`}
      disabled={disabled}
    >
      {icon} {text}
    </button>
  );
};

export default Button;
